export default __webpack_public_path__ + "static/media/gitaar-4.b77c0990.jpg";